import { render, staticRenderFns } from "./PartsSearch.vue?vue&type=template&id=bb88e480&scoped=true&"
import script from "./PartsSearch.vue?vue&type=script&lang=ts&"
export * from "./PartsSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PartsSearch.vue?vue&type=style&index=0&id=bb88e480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb88e480",
  null
  
)

export default component.exports